module.exports = __webpack_public_path__ + "assets/7770a4cc7c78b644b81a5562570490b9.svg";